import { defineStore } from "pinia";
import { ref } from "vue";
import { getEnvVar } from "@/utils/env";
import { AcvTokenClaims, USER_GROUP } from "vacv-components";

export const useUserStore = () => {
  return defineStore("user", function () {
    const defaultAudience = getEnvVar("VITE_DEFAULT_AUDIENCE") as USER_GROUP;
    const tokenFailureAudience = getEnvVar(
      "VITE_TOKEN_FAILURE_AUDIENCE"
    ) as USER_GROUP;

    const groups = ref<USER_GROUP>(defaultAudience);
    const user = ref<AcvTokenClaims>();

    const getUserInfo = async (): Promise<AcvTokenClaims | void> => {
      try {
        const userToken = await window.sso.getUserToken();
        const userInfo: AcvTokenClaims = window.sso.getUserInfo(userToken);
        user.value = userInfo;
        groups.value = userInfo.groups;
        return userInfo;
      } catch (e) {
        if (tokenFailureAudience) {
          groups.value = tokenFailureAudience; // if the token fails we will render the "guest" version of search-spa
        }
        return;
      }
    };

    const isB2BUser = async function () {
      try {
        const token = await window.sso.getUserToken();
        return window.sso.isB2BUser(token);
      } catch (e) {
        return false;
      }
    };

    const getSirevSid = async function () {
      return window.sso.getSirevSid();
    };

    return {
      user,
      groups,
      getUserInfo,
      isB2BUser,
      getSirevSid,
    };
  })();
};
